// Generated by CoffeeScript 2.7.0
var Admin__WebhooksController;

import SettingsPanel from '../concerns/settings_panel.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import Webhook from 'trunks/vue/admin/compositions/webhook/webhook.js';

export default Admin__WebhooksController = (function() {
  class Admin__WebhooksController extends Skylark.App.BaseController {
    index() {
      var _page, el, events, webhookVm, webhookable, webhookablePath;
      this.__toggleNavMenu();
      _page = this.getVars();
      webhookable = _page.webhookable;
      events = _page.events;
      webhookablePath = _page.webhookable_path;
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('webhook_edit');
      return webhookVm = new Webhook({
        el: el,
        propsData: {
          webhookablePath: webhookablePath,
          webhookable: webhookable,
          allEvents: events
        }
      });
    }

  };

  Admin__WebhooksController.include(ToggleNavMenuAction);

  return Admin__WebhooksController;

}).call(this);
